const EnemyNames = {
  SULLEN: "SULLEN",
  BOULDA: "BOULDA",
};

export default EnemyNames;
